import React from "react";
import ReactDOM from "react-dom";
import styled from "@emotion/styled";

import Form from "./Form";

function Modal(props) {
  return ReactDOM.createPortal(
    <ModalStyled>
      <Form {...props} />
    </ModalStyled>,
    document.querySelector("#modal")
  );
}

const ModalStyled = styled.div`
  position: fixed; /* Stay in place */
  z-index: 1; /* Sit on top */
  left: 0;
  top: 0;
  width: 100%; /* Full width */
  height: 100%; /* Full height */
  overflow: auto; /* Enable scroll if needed */
  background-color: rgb(0, 0, 0); /* Fallback color */
  background-color: rgba(0, 0, 0, 0.4);
`;

export default Modal;
